import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { DataTablePagerComponent as SuperDataTablePagerComponent } from '@swimlane/ngx-datatable';
@Component({
  selector: 'app-datatable-pager',
  templateUrl:
    './console/app-js/modules/product/components/keywords/kewords-pager/keywords-pager.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTablePagerComponent extends SuperDataTablePagerComponent {
  @Input() pagerLeftArrowIcon = 'icon-left';
  @Input() pagerRightArrowIcon = 'icon-right';
  @Input() pagerPreviousIcon = 'icon-prev';
  @Input() pagerNextIcon = 'icon-skip';
  @Input('class') class: string;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Input()
  _count = 0;
  _page = 1;
  _size = 0;
  pages: any;
  public _visiblePagesCount = 3;
  /**
   * set pages and size
   */
  set size(val: number) {
    this._size = val;
    this.pages = this.calcPages();
  }
  /**
   * get size
   */
  get size(): number {
    return this._size;
  }

  @Input()
  /**
   * sets total count of rows
   */
  set count(val: number) {
    this._count = val;
    this.pages = this.calcPages();
  }
  /**
   * gets count
   */
  get count(): number {
    return this._count;
  }

  @Input()
  /**
   * sets the page you are on
   */
  set page(val: number) {
    this._page = val;
    this.pages = this.calcPages();
  }

  /**
   * gets the page you are on
   */
  get page(): number {
    return this._page;
  }
  /**
   * gets the the total page count
   */
  get totalPages(): number {
    const count = this.size < 1 ? 1 : Math.ceil(this.count / this.size);
    return Math.max(count || 0, 1);
  }
  @Input()
  /**
   * sets the the visible paging limit
   */
  set visiblePagesCount(val: number) {
    this._visiblePagesCount = val;
    this.pages = this.calcPages();
  }
  /**
   * gets the the visible paging limit
   */
  get visiblePagesCount(): number {
    return this._visiblePagesCount;
  }
  /**
   * checks if you can navigate to previous page
   */
  canPrevious(): boolean {
    return this.page > 1;
  }

  /**
   * checks if you can navigate to next page
   */
  canNext(): boolean {
    return this.page < this.totalPages;
  }

  /**
   * moves to previous page
   */
  prevPage(): void {
    this.selectPage(this.page - 1);
  }
  /**
   * moves to next page
   */
  nextPage(): void {
    this.selectPage(this.page + 1);
  }
  /**
   * selects pages during pagination
   * @param page
   */
  selectPage(page: number): void {
    if (page > 0 && page <= this.totalPages && page !== this.page) {
      this.page = page;

      this.change.emit({
        page
      });
    }
  }
  /**
   * calculate total number of pages
   * @param page
   */
  calcPages(page?: number): any[] {
    const pages = [];
    let startPage = 1;
    let endPage = this.totalPages;
    const maxSize = this.visiblePagesCount;
    const isMaxSized = maxSize < this.totalPages;

    page = page || this.page;

    if (isMaxSized) {
      startPage = page - Math.floor(maxSize / 2);
      endPage = page + Math.floor(maxSize / 2);

      if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(startPage + maxSize - 1, this.totalPages);
      } else if (endPage > this.totalPages) {
        startPage = Math.max(this.totalPages - maxSize + 1, 1);
        endPage = this.totalPages;
      }
    }
    for (let num = startPage; num <= endPage; num++) {
      pages.push({
        number: num,
        text: <string>(<any>num)
      });
    }
    return pages;
  }
  /**
   * Pagination Function:
   * Get the Page Status for the set
   */
  private getPageStatus(): string {
    let page = this._page;
    let totalRows = this.count;
    let currentSet = page * this.size;
    let fromSet = currentSet - this.size + 1;
    // last page
    if (page === this.totalPages) {
      currentSet = this.count;
      fromSet = (this.totalPages - 1) * 100 + 1;
    }
    // return 'Page: ' + page + ', Displaying: ' + fromSet + '-' + currentSet + ' of ' + totalRows ;
    return (
      'Displaying from ' + fromSet + ' to ' + currentSet + ' of ' + totalRows
    );
  }
}
